<template>
  <v-expansion-panels focusable>
    <v-expansion-panel v-for="(item, i) in doubts" :key="i">
      <v-expansion-panel-header>
        {{ item.title }}
      </v-expansion-panel-header>
      <v-expansion-panel-content class="text-justify mt-5">
        {{ item.text }}
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>


<script>
export default {
  name: "CommonQuestions",
  data() {
    return {
      doubts: [
        {
          title: "O que é o Olhadela?",
          text: "O Olhadela foi construído para que Empresas ou Empreendedores, de diversos portes, possam divulgar os seus Produtos/Serviços, em um ambiente online exclusivo; e para Pessoas possam encontrar Produtos/Serviços próximos da sua localização, ou de onde quiser buscar.",
        },
        {
          title: "Como funciona o Olhadela?",
          text: "O Olhadela funciona como uma Vitrine Virtual, em que Clientes podem visualizar produtos/Serviços e contatar os seus respectivos “Anunciantes”. Assim como Empresas ou Empreendedores podem utilizar o seu espaço, gratuito, no Olhadela como uma Página Online para divulgar os seus Produtos/Serviços e utilizá-los em suas redes sociais.",
        },
        {
          title: "Como realizar o Cadastro como Visitante no Olhadela?",
          text: "Para realizar o Cadastro dentro do Olhadela basta clicar no botão “FAÇA SEU LOGIN”e utilizar o seu E-mail, Conta no Google ou do Facebook; depois cadastrar os seus dados completos, que irão facilitar sua navegação no Olhadela; e clicar em Enviar. Prontinho, você tem um ambiente totalmente seu, que pode ser editado clicando no Menu, e para salvar seus favoritos ou mesmo cadastrar o seu Negócio, caso possua.",
        },
        {
          title: "Como Funciona a Busca dentro do Olhadela?",
          text: "Ao ser digitado o que se procura, dentro dos nossos campos de busca, O Olhadela apresenta todas opções que se encontram próximas de você, utilizando a sua localização atual, podendo ser notado na parte superior ou no menu. Para que possam ser realizadas buscas em outros lugares, que não seja o que você se encontra no momento, basta alterar sua localização no menu ou no canto do Olhadela.",
        },
        {
          title: "Gostei do que vi. Como Contatar a Empresa ou Anunciante?",
          text: "Ao clicar no Produto/Serviço que se interessou, você terá acesso aos Detalhes, Valores (que podem estar ou não estar disponíveis), Localização e Botões de Contato (que podem ser Telefone, Whatsapp, Facebook, Instagram ou E-mail). Destaforma você irá contatar diretamente o “Anunciante”, através do clique nos Botões deContato. Simples e direto ao ponto!",
        },
        {
          title:
            "Posso Salvar ou mesmo Compartilhar nas minhas Redes Sociais Produtos/Serviços que encontrei no Olhadela?",
          text: "Ao clicar no Produto/Serviço desejado há um botão “Salvar”. Ao clicar nele o Produto/Serviço irá para sua Lista de Salvos, e uma pop-up irá abrir questionando seo “Anunciante” poderá ou não contatar você para falar sobre o seu interesse. Assim que “Salvo” você poderá Compartilhar nas suas Redes Sociais.",
        },
        {
          title: "Como Cadastrar o meu Negócio do Olhadela?",
          text: "Clique no botão “CADASTRAR NEGÓCIO”, depois fará o seu Login ou Cadastro (como descrito na pergunta 3: “Como realizar o cadastro como Visitante no Olhadela?”). Após este procedimento basta seguir o passo a passo, preenchendo cada informação corretamente: Dados Gerais do Negócio > Informações Específicas> Cadastrar Foto, Contato e breve Descrição. Prontinho, a página do seu Negócio está pronta.",
        },
        {
          title:
            "Como Cadastrar os Produtos/Serviços do meu Negócio no Olhadela?",
          text: "Após feito o Cadastro do seu Negócio no Olhadela, você terá acesso ao painel Administrativo (que pode ser acessado em PERFIL > NEGÓCIO > SELECIONAR NEGÓCIO), lá você irá encontrar um botão “ADICIONAR PRODUTO”. Ao clicar nele abrirá uma página em que você irá colocar as Fotos do Produto/Serviço, Nome, Categoria do Produto/Serviço, Descrição, Valor e Valor Promocional, caso haja. Parafinalizar clique em Salvar. Prontinho, o seu produto está cadastrado e visível para todos os visitantes.",
        },
        {
          title:
            "O que irei encontrar no Painel Administrativo do meu Negócio no Olhadela?",
          text: "No Painel Administrativo você tem acesso a Localização, E-mail, Contatos, Produtos para Edição e Quantidade de Visualizações, opções para Editar a Página, além da Caixa de Mensagens do Seu Negócio. Nele você poderá gerenciar todo o seu ambiente online no Olhadela.",
        },
        {
          title:
            "Como divulgar a página do meu Negócio, criada no Olhadela, nas minhas Redes Sociais?",
          text: "No seu Painel Administrativo, ao ter acessado o painel específico do seu Negócio, há a opção “VISUALIZAR LOJA”. Ao clicar nesta opção, você é direcionado para a Página do seu Negócio, que será a mesma que os seus Clientes irão visualizar. Basta copiar o link, que está no endereço do seu navegador, e compartilhar nas suasRedes Sociais.",
        },
        {
          title:
            "Posso Cadastrar mais de um Negócio no Olhadela utilizando apenas um Perfil logado?",
          text: "Sim! Ao acessar o menu do seu Perfil e ir à sessão “NEGÓCIOS”, lá você irá visualizaro Negócio cadastrado, caso tenha feito, e a opção para Cadastrar novos empreendimentos. Nesta mesma sessão você poderá navegar pelos seus Negócios Cadastrados e gerenciá-los.",
        },
        {
          title: "Desejo falar com a Equipe de Suporte, como proceder?",
          text: "Para entrar em contato com a Equipe da Almeida Technologies, responsável pelo Olhadela, basta utilizar o formulário de contato ao final da página; enviar um E-mail para: contato@olhadela.digital; ou pelo whatsapp: (49) 3003-0944.",
        },
      ],
    };
  },
};
</script>
